<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pcrYQX/tc-custom/9781429909815.jpg?1731883558612" alt="This image is the cover for the book Illuminator"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Illuminator
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A glowing first novel that brings us "historical fiction in the grand epic manner, beautifully felt and written"</b><br/><br/>It is England, in the fourteenth century -- a time of plague, political unrest and the earliest stirrings of the Reformation. The printing press had yet to be invented, and books were rare and costly, painstakingly lettered by hand and illuminated with exquisite paintings. Finn is a master illuminator who works not only for the Church but also, in secret, for John Wycliffe of Oxford, who professes the radical idea that the Bible should be translated into English for everyone to read. Finn has another secret as well, one that leads him into danger when he meets Lady Kathryn of Blackingham Manor, a widow struggling to protect her inheritance from the depredations of Church and Crown alike. Finn's alliance with Lady Kathryn will take us to the heart of what Barbara Tuchman once called "the calamitous fourteenth century." <br/><br/>Richly detailed and irresistibly compelling, Brenda Rickman Vantrease's <i>The Illuminator</i> is a glorious story of love, art, religion, and treachery at an extraordinary turning point in history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Rickman Vantrease
      </h2>
      
      <p class="authorDescription body article"><P><B>Brenda Rickman Vantrease</B> is a former English teacher and librarian who has traveled extensively in the British Isles. She holds a doctorate in English from Middle Tennessee State University and lives in Nashville, Tennessee. <I>The Illuminator</I> is her first novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ST. MARTIN’S GRIFFIN
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7501e150